import { type JSONData } from "../../base_classes/dto.d";
import {
  PrintingOrderCorrespondenceTemplateKeyValues, PrintingOrderCorrespondenceTemplates,
  PrintingOrderDto,
} from "./dto.gen";
import { type IPrintingOrder } from "./entity.d";
import PrintingOrderParsers from "./parsers";
import PrintingOrderValidators from "./custom_validators";
import request from "@/data/api/request";
import { type PrintingOrderCorrespondenceTemplateKey } from "./dto.gen.d";

export class PrintingOrder extends PrintingOrderDto implements IPrintingOrder {
  constructor(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        },
    data?: JSONData,
  ) {
    super(data, PrintingOrderParsers, PrintingOrderValidators);

    if (data !== undefined) {
      // Set data
      this.set(data);
    }

    this.buildPathObject(pathVars);
  }
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  public async get(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        }
      | undefined,
  ): Promise<PrintingOrder> {
    return (await super.get(pathVars)) as PrintingOrder;
  }

  public async sendCorrespondence(
    key: PrintingOrderCorrespondenceTemplateKey,
  ): Promise<void> {
    // Parse data
    const parsedData = this._parser.parse(this.toJSON());

    // Send correspondence
    await request({
      url: `printing_order/${this.id}/correspondence/${key}`,
      method: "POST",
      data: parsedData,
    });
  }

  public canSendTemplate(key: PrintingOrderCorrespondenceTemplateKey): [boolean, string] {
    console.log(PrintingOrderCorrespondenceTemplateKeyValues, key)
    switch (key) {
      case PrintingOrderCorrespondenceTemplates.CUSTOMER_APPROVE_SAMPLE:
        return [!!this.files.artwork.url, "Missing artwork URL"];
      case PrintingOrderCorrespondenceTemplates.CUSTOMER_PRINTING_ORDER_RECEIVED:
        return [true, "printing order received"];
      case PrintingOrderCorrespondenceTemplates.CUSTOMER_TRACK_AND_TRACE:
        return [!!this.trackingUrl, "Missing track and trace url"];
      case PrintingOrderCorrespondenceTemplates.SUPPLIER_PRINTING_ORDER_RECEIVED:
        return [true, "printing order received"];
      case PrintingOrderCorrespondenceTemplates.SUPPLIER_SAMPLE_ACCEPTED:
        return [!!this.files.artwork.url, "Missing artwork URL"];
      case PrintingOrderCorrespondenceTemplates.SUPPLIER_SAMPLE_REJECTED:
        return [!!this.files.artwork.url, "Missing artwork URL"];
      default:
        return [false, "unknown template " + key ];
    }
  }

  /// ///////////////////////////////////////
  /// /////////// STATIC METHODS ////////////
  /// ///////////////////////////////////////

  static override FromJSON(data?: JSONData): PrintingOrder {
    return new PrintingOrder(undefined, data);
  }

  static override FromJSONArray(data: JSONData[]): PrintingOrder[] {
    return data.map((item) => PrintingOrder.FromJSON(item));
  }

  static FromDto(dto: PrintingOrderDto): PrintingOrder {
    return new PrintingOrder(undefined, dto.toJSON());
  }

  static async SyncExternalPrintingOrders(): Promise<void> {
    await request({
      url: "external/printing_orders",
      method: "GET",
    });
  }
}
